export const getInitials = (name: string) => {
	if (!name) return "";
	return name
		.split(" ")
		.filter(Boolean)
		.map(part => part.charAt(0))
		.join("")
		.toUpperCase()
		.slice(0, 2);
};

export const getAvatarUrl = (user: any) => {
	return user?.profileImage || user?.avatar || user?.profile?.image || undefined;
};
